// Flash zprávy (.alert-fixed): nejdřív výrazně nahoře uprostřed, po chvíli se stáhnou
// do malé karty vpravo dole (mimo menu i tlačítka formulářů) a tam po pár vteřinách zmizí.
// Klik na velkou zprávu ji stáhne hned, najetí myší na malou kartu odpočet pozastaví.

const ICONS = {
    success: 'bi-check-circle-fill',
    info: 'bi-info-circle-fill',
    warning: 'bi-exclamation-triangle-fill',
    danger: 'bi-x-circle-fill',
};

// [velká zpráva, malá karta] v ms – chyby a varování zůstávají déle
const DURATIONS = {
    success: [1500, 4000],
    info: [2000, 5000],
    warning: [3000, 8000],
    danger: [5000, 12000],
};

const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

class FlashesExtension {
    initialize(naja)
    {
        if (document.readyState === 'loading') {
            window.addEventListener('DOMContentLoaded', this.onLoad.bind(this));
        } else {
            this.onLoad();
        }
        naja.addEventListener('complete', this.closeAlerts.bind(this));
    }

    onLoad()
    {
        const container = document.querySelector('.alert-fixed');
        if (container) {
            container.querySelectorAll('.alert').forEach((alert) => this.showFlash(alert));

            // Snippet "flashes" po AJAXu i zprávy přidané z JS ($('.alert-fixed').append(...))
            new MutationObserver((mutations) => {
                mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('alert')) {
                        this.showFlash(node);
                    }
                }));
            }).observe(container, { childList: true });
        }

        this.closeAlerts();
    }

    getDock()
    {
        let dock = document.querySelector('.flash-dock');
        if (!dock) {
            dock = document.createElement('div');
            dock.className = 'flash-dock';
            dock.setAttribute('aria-live', 'polite');
            document.body.appendChild(dock);
        }

        return dock;
    }

    showFlash(alert)
    {
        if (alert.dataset.flash) {
            return;
        }
        alert.dataset.flash = 'hero';

        if (this.isEmpty(alert)) {
            alert.remove();
            return;
        }

        const type = Object.keys(ICONS).find((t) => alert.classList.contains('alert-' + t)) || 'info';
        const [heroMs, dockMs] = DURATIONS[type];

        alert.classList.add('flash', 'flash--hero', 'flash--' + type);
        alert.classList.remove('mt-3', 'fade');
        alert.style.setProperty('--flash-dock-ms', dockMs + 'ms');
        alert.setAttribute('role', type === 'danger' ? 'alert' : 'status');

        if (!alert.querySelector('.flash__icon')) {
            const icon = document.createElement('i');
            icon.className = 'bi flash__icon ' + ICONS[type];
            alert.prepend(icon);
        }

        const closeButton = alert.querySelector('.btn-close');
        if (closeButton) {
            // zavírání řešíme sami (s animací), ne přes Bootstrap
            closeButton.removeAttribute('data-bs-dismiss');
            closeButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.dismiss(alert);
            });
        }

        // alert-sticky (hláška s POK z EET) zůstává nahoře, dokud ji nezavře uživatel – POK si potřebuje opsat
        if (alert.classList.contains('alert-sticky')) {
            return;
        }

        alert.addEventListener('click', () => this.toDock(alert));

        // Konec odpočtu malé karty (progress bar ::after) = zavřít
        alert.addEventListener('animationend', (e) => {
            if (e.animationName === 'flash-countdown') {
                this.dismiss(alert);
            }
        });

        alert.flashTimer = setTimeout(() => this.toDock(alert), heroMs);
    }

    toDock(alert)
    {
        if (alert.dataset.flash !== 'hero') {
            return;
        }
        alert.dataset.flash = 'dock';
        clearTimeout(alert.flashTimer);

        const first = alert.getBoundingClientRect();
        this.getDock().appendChild(alert);
        alert.classList.replace('flash--hero', 'flash--compact');

        if (reducedMotion() || !alert.animate) {
            return;
        }

        // FLIP: z místa velké zprávy do rohu
        const last = alert.getBoundingClientRect();
        const dx = (first.left + first.width / 2) - (last.left + last.width / 2);
        const dy = (first.top + first.height / 2) - (last.top + last.height / 2);
        const scale = last.height ? first.height / last.height : 1;

        alert.animate([
            { transform: `translate(${dx}px, ${dy}px) scale(${scale})`, opacity: 0.6 },
            { transform: 'none', opacity: 1 },
        ], { duration: 500, easing: 'cubic-bezier(.2, .8, .2, 1)' });
    }

    dismiss(alert)
    {
        if (alert.dataset.flash === 'closing') {
            return;
        }
        alert.dataset.flash = 'closing';
        clearTimeout(alert.flashTimer);

        if (reducedMotion() || !alert.animate) {
            alert.remove();
            return;
        }

        alert.animate([
            { opacity: 1, transform: 'none' },
            { opacity: 0, transform: 'translateX(30px)' },
        ], { duration: 250, easing: 'ease-in' }).onfinish = () => alert.remove();
    }

    isEmpty(alert)
    {
        const tempAlert = alert.cloneNode(true);
        tempAlert.querySelectorAll('.btn-close, .flash__icon').forEach((el) => el.remove());

        return tempAlert.textContent.trim() === '';
    }

    // Ostatní (inline) alerty na stránce: prázdné odstranit, zavíratelné zavřít po 6 s
    closeAlerts()
    {
        document.querySelectorAll('.alert:not(.flash)').forEach((alert) => {
            if (alert.closest('.alert-fixed')) {
                return;
            }

            if (this.isEmpty(alert)) {
                alert.remove();
                return;
            }

            const closeButton = alert.querySelector('.btn-close');
            if (closeButton) {
                setTimeout(() => closeButton.click(), 6000);
            }
        });
    }
}

export default FlashesExtension;
